module.exports = __webpack_public_path__ + "img/down_arrow_icon.0393c961.svg";